export default __webpack_public_path__ + "media/images/svg/phone-4a8898d35ce8b7fe12dea5fa537d39c2.svg";